export enum LimitOrderStatus {
    WATCH = "WATCH",
    FIRED = "FIRED",
    CONSUMED = "CONSUMED",
    CANCELED = "CANCELED",
    FAILED = "FAILED",
}

export enum ExecutionType {
    GRID = 'GRID',
    LIMIT = 'LIMIT',
}